/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TakeHomeLink } from './TakeHomeLink';
import {
    TakeHomeLinkFromJSON,
    TakeHomeLinkFromJSONTyped,
    TakeHomeLinkToJSON,
    TakeHomeLinkToJSONTyped,
} from './TakeHomeLink';
import type { LearnVisit } from './LearnVisit';
import {
    LearnVisitFromJSON,
    LearnVisitFromJSONTyped,
    LearnVisitToJSON,
    LearnVisitToJSONTyped,
} from './LearnVisit';

/**
 * 
 * @export
 * @interface EndMyLearnVisit200Response
 */
export interface EndMyLearnVisit200Response {
    /**
     * State at the moment of ending. For a deleted empty visit this describes a row
     * that no longer exists — it is returned so the client can render a closing
     * screen, not so it can be read back.
     * 
     */
    visit: LearnVisit;
    /**
     * One entry per participant. **Empty when the visit held zero attempts and zero
     * artifacts** and was therefore deleted rather than retained.
     * 
     */
    takeHomeLinks: Array<TakeHomeLink>;
    /**
     * Same namespace as `MyVisit.warnings`. Restated here because the end screen is
     * where a pair sees how many links they got.
     * 
     * `single_participant_team` at this point is **informational, not actionable**:
     * the visit has ended, so `PATCH /learn/visits/me` returns `409` and no
     * facilitator route adds a participant either. Render it as "you have one link
     * — share it", never as an error the learner could have avoided. The version
     * that changes the outcome is the one on `GET /learn/visits/me`, emitted while
     * the visit is still active.
     * 
     */
    warnings?: Array<EndMyLearnVisit200ResponseWarningsEnum>;
}


/**
 * @export
 */
export const EndMyLearnVisit200ResponseWarningsEnum = {
    SingleParticipantTeam: 'single_participant_team',
} as const;
export type EndMyLearnVisit200ResponseWarningsEnum = typeof EndMyLearnVisit200ResponseWarningsEnum[keyof typeof EndMyLearnVisit200ResponseWarningsEnum];


/**
 * Check if a given object implements the EndMyLearnVisit200Response interface.
 */
export function instanceOfEndMyLearnVisit200Response(value: object): value is EndMyLearnVisit200Response {
    if (!('visit' in value) || value['visit'] === undefined) return false;
    if ((!('takeHomeLinks' in (value as Record<string, any>)) && !('take_home_links' in (value as Record<string, any>))) || ((value as Record<string, any>)['takeHomeLinks'] === undefined && (value as Record<string, any>)['take_home_links'] === undefined)) return false;
    return true;
}

export function EndMyLearnVisit200ResponseFromJSON(json: any): EndMyLearnVisit200Response {
    return EndMyLearnVisit200ResponseFromJSONTyped(json, false);
}

export function EndMyLearnVisit200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EndMyLearnVisit200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'visit': LearnVisitFromJSON(json['visit']),
        'takeHomeLinks': ((json['take_home_links'] as Array<any>).map(TakeHomeLinkFromJSON)),
        'warnings': json['warnings'] == null ? undefined : json['warnings'],
    };
}

export function EndMyLearnVisit200ResponseToJSON(json: any): EndMyLearnVisit200Response {
    return EndMyLearnVisit200ResponseToJSONTyped(json, false);
}

export function EndMyLearnVisit200ResponseToJSONTyped(value?: EndMyLearnVisit200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visit': LearnVisitToJSON(value['visit']),
        'take_home_links': ((value['takeHomeLinks'] as Array<any>).map(TakeHomeLinkToJSON)),
        'warnings': value['warnings'],
    };
}

